import { useLocalStorage } from "@/hooks/use-local-storage";
import { Dashboard } from "./Dashboard";
import { OwnerDashboard } from "./OwnerDashboard";

type ViewMode = "owner" | "client";

/**
 * DashboardWrapper
 *
 * Reads the `sera-view-mode` localStorage key (set by the Header view toggle)
 * and renders the appropriate dashboard:
 *   - "owner" → OwnerDashboard (outreach pipeline, lead funnel, call volume trends)
 *   - "client" → Dashboard (Sera stats: calls answered, booked, conversion, handle time)
 */
export const DashboardWrapper = () => {
  const [viewMode] = useLocalStorage<ViewMode>("sera-view-mode", "owner");

  if (viewMode === "client") {
    return <Dashboard />;
  }

  return <OwnerDashboard />;
};
